import {GOAL_BUDGET_EXAMPLES} from './goalBudgetExamples';

export const GOAL_ASSETS = [
  ['home','خرید خانه','01-goal-house'], ['vehicle','خرید ماشین','02-goal-car'],
  ['laptop','خرید لپ‌تاپ','03-goal-laptop'], ['tablet','خرید تبلت','04-goal-tablet'],
  ['phone','خرید موبایل','05-goal-phone'], ['custom','پس‌انداز دلخواه','06-goal-savings-box'],
  ['migration','مهاجرت','07-goal-migration'], ['university','تحصیل در دانشگاه','08-goal-university'],
  ['appliances','جهیزیه و لوازم خانه','09-goal-home-appliances'], ['jewelry','خرید سرویس طلا','10-goal-gold-jewelry'],
  ['travel','سفر خارجی','11-goal-international-travel'], ['gold','خرید شمش طلا','12-goal-gold-ingot'],
  ['silver','خرید شمش نقره','13-goal-silver-ingot'], ['copper','خرید شمش مس','14-goal-copper-ingot'],
].map(([id,label,asset]) => ({id,label,asset,...GOAL_BUDGET_EXAMPLES[id]}));
export function resolveGoalAsset(goal) {
  if (typeof goal === 'object' && goal?.title) {
    const named = GOAL_ASSETS.find(item => item.label === goal.title.trim());
    if (named) return named.asset;
  }
  const value = typeof goal === 'string' ? goal : goal?.category || goal?.type || goal?.icon;
  const aliases = {house:'home',car:'vehicle',education:'university',general:'custom'};
  return (GOAL_ASSETS.find(item => item.id === (aliases[value] || value)) || GOAL_ASSETS[5]).asset;
}
